const en = {
  sidebar: {
    merchant: {
      phone: 'Phone',
      vat: 'VAT',
      email: 'Email'
    },

    menu: {
      dashboard: 'Dashboard',
      archive: 'Archive',
      payments: 'Payments',
      bookings: 'Booking',
      paymentinformation: 'Payment Information',
      profile: 'Profile',
      paymentsettings: 'Payment Settings',
      wait_list: 'Waiting list',
      kamstrup: 'Water Usage',
      kamstrup_alarm_settings: 'Water Alarm Settings'
    },

    profile: {
      home: 'Home',
      profile: 'Profile',
      logout: 'Log Out'
    }
  },

  modals: {
    nets_notice: 'You must now set up your card and therefore leave Zietwing and continue in the Nets payment window.',
    mobile_pay_notice: 'You will now be redirected to the Landing page and need to accept agreement in MobilePay application.',
    vipps_notice: 'You will now be redirected to the Landing page and need to accept payment in Vipps/MobilePay application.',
    vipps_notice_recurring: 'You will now be redirected to the Landing page and need to accept agreement in Vipps/MobilePay application.',
    vipps_notice_later: 'You will get a push notification in Vipps/MobilePay application on Transaction date ({transaction_date}) and will need to accept the payment.',
    overdue_payment_notice: 'You are about to pay {amount} DKK for overdue transaction.',

    overdue_fee: {
      unscheduled: 'You are about to pay {amount} DKK for overdue fee.'
    },

    booking: {
      mobile_pay_notice: 'Please note that with MobilePay system the Booking is paid while activating',
      vipps_notice: 'Please note that with Vipps/MobilePay the amount is reserved when activating and charged at the payment time. If the payment time is more than 4 days ahead, you approve an agreement and are charged on the payment date.',
      booking_time_notice: 'Please note that once the booking time has expired, your reservation is over.'
    },

    logout: {
      areyousure: 'Are you sure you want to log out?'
    },

    changeemail: {
      header: 'Change Email',
      form: {
        new_email: 'New Email',
        password: 'Password'
      }
    },

    changepassword: {
      header: 'Change Password',
      form: {
        old_password: 'Old Password',
        new_password: 'New Password',
        confirm_password: 'Confirm Password'
      }
    },

    newsubscriptionmodal: {
      product: {
        title: 'Product',
        description: 'Information regarding your product',
        content: {
          description: 'Description'
        }
      },

      accessories: {
        title: 'Accessories',
        description: 'Pick Accessories',
        content: {
          header: 'Select your wanted accessories'
        }
      },

      details: {
        title: 'Details',
        description: 'Product Details',
        content: {
          header: 'Details',
          transaction_date: 'Transaction Date',
          activation_later: 'Your subscription will be activated later',
        },

        agree_to: 'I agree to the',
        terms: 'Terms and Conditions'
      },

      payment: {
        title: 'Payment',
        description: 'Choose Payment Interval',
        content: {
          header: 'Choose Payment Interval',
          instant_payment: 'The selected amount will be charged immediately when you activate this service'
        }
      },

      payment_method: {
        title: 'Payment Method',
        description: 'Choose Payment Method',
        pay_by_card: 'Pay by card',
        default_payment_method: 'This payment method was preselected for the product.'
      },

      validation: {
        nets: {
          success: {
            payment_created: 'Payment created successfully!',
            payment_completed: 'Payment completed successfully! Activating...',
            subscription_details_saved: 'Subscription payment details saved successfully! Activating...',
            subscription_added: 'Your subscription has been added!',
            subscription_updated: 'Payment information has been updated! You will be redirected in a few seconds.',
            subscription_added_with_failed_charge: 'Your subscription has been added but charging failed!'
          }
        },

        errors: {
          no_interval_selected: 'Please select an interval before proceeding!',
          no_payment_method_selected: 'Please select a payment method before proceeding!',
          not_accepting_terms: 'Please accept terms and conditions before proceeding.',
          not_accepting_warning_message: 'Please accept warning message before proceeding!'
        }
      },

      intro: {
        readysubscribe: {
          title: 'You are now ready to subscribe',
          content: 'Press the subscribe button to finish your subscription.'
        },

        firstsubscription: {
          title: 'The Subscription Process',
          content: 'Welcome to the subscription process. Click the next button to proceed.'
        },

        productstab: {
          title: 'Products',
          content: 'Here you will be informed about the details of your product.'
        },

        accessoriestab: {
          title: 'Accessories',
          content: 'This is the accessories that are available for your product. In some cases an accessory could be mandatory. Please choose the accessories you wish to add.'
        },

        detailstab: {
          title: 'Details',
          content: 'In some cases you will be asked to fill out further information about yourself or the product you are signing up for. You will also be asked to accept the terms and conditions. Please do so now.'
        },

        forgotdetails: {
          title: 'Oops, you forgot something..',
          content: 'Please make sure you have correctly filled out the details and accepted the terms and conditions.'
        },

        paymenttab: {
          title: 'Payment Interval',
          content: 'You\'re almost there, now it\'s time to select an interval. When you have selected an interval it will ask you to attach a card. Please select an interval now.'
        },

        payment_method: {
          title: 'Choose the desired payment method',
          content_vipps: 'If you prefer to use Vipps, you can choose this payment method to activate subscription.'
        }
      }
    },

    newwaitlistmodal: {
      validation: {
        success: {
          waitlist_added: 'Your waitlist has been added!',
          waitlist_added_with_failed_charge: 'Your waitlist has been added but charging failed!',
          waitlist_details_saved: 'Waitlist payment details saved successfully! Activating...'
        }
      }
    },

    newbookingmodal: {
      free: 'Free',
      guest: {
        title: 'Bringing a guest?',
        label: 'I am bringing one guest',
        description: 'Reserve one additional sauna place for your guest. The sauna price and guest fee will be added to your total.',
        sauna_price: 'Sauna price',
        fee: 'Guest fee',
        additional_cost: 'Additional cost',
        included: 'This booking includes one guest',
        price: 'Guest (sauna price and guest fee)',
        confirmation: 'Adding a guest reserves one additional place and increases the total price by {amount}. Continue?',
        capacity_unavailable: 'A guest cannot be added because fewer than two places are available for the selected time.',
        locked: 'The guest option cannot be changed after payment has started.'
      },
      select_active_subscription: 'Select an active subscription (fields marked with an asterisk (*) are mandatory)',
      product: {
        title: 'Product',
        description: 'Information regarding your reservation',
        content: {
          description: 'Description'
        }
      },

      time: {
        title: 'Time',
        description: 'Book your date',
        content: {
          no_time: 'No available times'
        },
        no_available_slots: 'Unfortunately, there are no available slots left for the selected time.',
        available_slots: 'There are {amount} available slots for the selected time.'
      },

      winter_place: {
        title: 'Winter Place',
        description: 'Select winter place for your boat',
        title_not_chosen: 'Select winter place for your boat *',
        description_not_chosen: 'Click on the button below to open the image',
        title_chosen: 'Selected winter place: {place}',
        description_chosen: 'Click on the button below to open the image and reselect the place',
        open_image: 'Open map',
        reset_view: 'Reset view',
        close: 'Close',
        confirm_message: 'Please confirm that you select "{place}"',
        click_to_open: 'Click on the button below to open the map',
        existing_place: {
          title: 'Important',
          text1: 'You\'ve already selected the sector "{existingWinterPlace}".',
          text2: 'Do you want to replace your previous selection?',
          overwrite_checkbox: {
            label: 'Overwrite selected sector',
            modal_text: 'If you uncheck this checkbox, current place will be reset to your previously selected - {existingWinterPlace}. Are you sure?'
          },
          bottom_text: 'Your current selection'
        }
      },

      details: {
        title: 'Details',
        description: 'Booking details',
        content: {
          header: 'Details'
        }
      },

      warning_message: {
        title: 'Warning message',
        description: 'Double check your choice',
        content: {
          header: 'Attention',
          agree: 'I agree'
        }
      },

      confirm: {
        title: 'Confirm',
        description: 'Verify your booking',
        content: {
          header: 'Confirm your booking',

          time: 'Time',

          pricing: 'Price',

          validation: {
            no_date_picked: 'No date picked',
            no_time_picked: 'No time picked',
            no_year_picked: 'No year picked',
            no_payment_method_picked: 'No payment method picked'
          }
        }
      },

      validation: {
        subscription_field: 'Please make sure that you have selected all the required subscriptions (marked with an asterisk (*))',
        not_all_subscriptions_chosen: "Not all the required subscriptions are selected. Please contact Merchant ({merchant}) to resolve the issue",

        nets: {
          success: {
            details_saved: 'Payment details have been saved! You will be redirected in few seconds...'
          }
        },

        success: {
          booking_reserved: 'Your booking has been reserved!',
          booking_reserved2: 'You can see your booked reservations under "Booking" in the sidebar'
        },

        errors: {
          something_is_missing: 'Something is missing!',
          fill_out_missing: 'Please fill out the missing data!',
          subscription_field_incorrect: 'Please make sure that you have selected all the required subscriptions!',
          no_available_time: 'Unfortunately, no available time slots left for the selected period of time!',
        }
      }
    },

    paymentterms: {
      header: 'Accept Merchant Payment Terms'
    },

    termsandconds: {
      accept_header: 'Accept the terms and conditions',
      normal_header: 'Terms And Conditions'
    },

    availableproducts: {
      header: 'Add New Product',

      card: {
        button: 'Add Product'
      },

      not_available: 'Not available at the moment',

      intro: {
        categories: {
          title: 'Categories',
          content: 'Here you can see all available categories'
        },
        products: {
          title: 'Products',
          content: 'Here you can select desired product to subscribe. Click on "Add Product" to continue'
        }
      },

      validation: {
        success: {
          new_product: 'New Product added successfully!',
          follow_process: 'Please go through the process to setup your service.'
        }
      }
    },

    available_accessories: {
      not_available: 'Unfortunately, no accessory left in storage. Please contact merchant!'
    },

    missed_something: {
      title: 'Are you missing something?',
      header: 'You have not filled out all of your services!',
      body: '<p><span class="ui label">{total}</span> services has not been filled out yet!</p><p>Please press "Next" to finish this now.</p>'
    },

    keep_going: {
      title: 'Keep going!',
      header: 'You\'re not done yet',
      body: '<p>You have <span class="ui label">{total}</span> services to complete left!</p> <p> Click "Next" to move on!</p>'
    },

    social_number: {
      title: 'Social number (CPR) missing',
      header: 'Dear {username},',
      body: '<p>Please set your Social Number in Profile settings. <br> This is needed for invoicing in <b>KMD Opus Debitor</b>. <br> Click "Next" to continue.</p>'
    },

    overdue: {
      title: 'You have overdue transactions!',
      header: 'Please click "Pay" in order to settle your outstanding payment',
      body: '<p>This may happen if your payment card has expired or has insufficient funds. Please make sure your payment card is valid and up to date.</p>',
      update_card: 'Update Payment Card'
    },

    expired_card: {
      title: 'Your credit card is expired!',
      header: 'Dear {firstname} {surname},',
      body: '<p>Please click "Next" to update your payment information on the {container} <b>{product_name}</b>.</p>'
    },

    update_payment_card: {
      title: 'Overdue payment not possible!',
      header: 'We were not able to charge overdue payment. Please check your payment card.',
      body: '<p>In order to update payment information, click <b>"Next"</b>.</p><p>You can also update your payment information by click <b>"Change card"</b> button.</p>'
    },

    payment_system_update: {
      title: 'Payment details are missing!',
      header: 'Dear {firstname} {surname},',
      body: '<p>Please click "Next" to add your payment information for the {container} <b>"{product_name}"</b>.</p>'
    }

  },

  globals: {
    buttons: {
      yes: 'Yes',
      no: 'No',
      cancel: 'Cancel',
      cancel_subscription: 'Cancel subscription',
      cancel_waitlist: 'Cancel waiting list',
      cancel_booking: 'Cancel booking',
      update: 'Update',
      edit: 'Edit',
      save: 'Save',
      save_and_complete: 'Save & Complete',
      save_changes: 'Save Changes',
      next: 'Next',
      previous: 'Previous',
      subscribe: 'Subscribe',
      activate: 'Activate',
      choose_paymentmethod: 'Choose Payment Method',
      accept: 'Accept',
      change: 'Change',
      select: 'Select',
      deselect: 'Deselect',
      delete: 'Delete',
      attach: 'Attach',
      done: 'Done',
      close: 'Close',
      skip: 'Skip',
      next_step: 'Next step',
      finalize: 'Finalize Setup',
      change_card: 'Change Card',
      add_payment_method: 'Add Payment Method',
      continue: 'Continue',
      finish: 'Finish',
      reserve: 'Reserve',
      open: 'Open',
      pay: 'Pay',
      pay_overdue_fee: 'Pay overdue fee',
      overdue_fee_paid: 'Overdue fee paid',
      pay_overdue_payment: 'Pay overdue payment',
      pay_with_nets: 'Pay with Nets Easy',
      pay_with_mobilepay: 'Pay with MobilePay'
    },

    accessories: {
      no_accessory_left: 'No accessory left in stock.',
      no_accessory_left_full: 'No accessory left in stock. Please contact Merchant!'
    },

    container: {
      subscription: 'Subscription',
      waitlist: 'Waitlist',
      booked: 'Booking'
    },

    status: {
      'unset': 'Unfinished',
      'deleted': 'Deleted',
      'active': 'Active',
      'delayed': 'Delayed',
      'free': 'Free',
      'activating': 'In activation',
      'setup_processing': 'Setting up payment method'
    },

    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],

    monthsshort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],

    loaders: {
      loading: 'Loading...'
    },

    validation: {
      success: {
        success: 'Success!',
        payment_successful: 'Your attachment was successful',
        overdue_fee_payment_successful: 'Overdue Fee paid successfully',
        overdue_payment_successful: 'Overdue payment was successful',
        startup_fee_payment_successful: 'Startup Fee paid successfully'
      },

      warning: {
        warning: 'Warning!',
        not_all_steps_completed: 'Oops, something is wrong. Your {0} is incomplete, please contact Merchant.'
      },

      errors: {
        error: 'Error..',
        payment_title: 'Payment not completed',
        overdue_fee_payment_failed: 'There was an error charging overdue fee. Please try again later',
        overdue_payment_failed: 'Overdue payment failed',
        something_went_wrong: 'Something went wrong...',
        payment_failed: 'Something went wrong with your payment...',
        nothing_found: 'Nothing found...',
        oops_outdated_browser: 'You are using an outdated browser!',
        outdated_browser_message: 'We suggest downloading Google Chrome for a smoother experience. <a href="https://google.dk/chrome">Click here</a> to download!',
        try_again_later: 'Please try again later..',
        charge_failed: 'Card attached but charging failed.',
        contact_merchant: 'Please try again later, or contact merchant..',
        missing_parameters: 'You have not filled all the fields in your Profile. You will redirected in few seconds!',
        startup_fee_payment_not_completed: 'Startup Fee payment not completed',
      },

      warnings: {
        are_you_sure: 'Are you sure?'
      }
    },

    transactions: {
      no_card_attached: 'transaction declined (card missing)'
    },

    confirm: {
      confirm_leave: 'Do you really want to leave? You have unsaved changes!'
    },

    checkout: {
      title: 'Checkout',

      success: {
        title: 'Checkout completed!',
        payment_title: 'Payment completed!',
        text: 'Information about your {0} will be updated soon. Click on the button below to continue.',
        text_for_overdue: 'Overdue payment has been successfully processed. Click on the button below to continue.',
        text_with_overdue_fee: 'Payment information has been successfully added. Click on the button below to continue.',
        update_text: 'Information about your {0} has been successfully updated. Click on the button below to continue.',
        button_text: 'Continue'
      },

      failed: {
        title: 'Payment not completed!',
        text: 'Unfortunately, we were not able to complete your payment.',
        additional_text: 'If your {0} is not updated after next 10 minutes, please contact the merchant!',
        click_to_continue_text: 'Click on the button below to continue.',
        button_text: 'Continue',

        vipps: {
          text: 'Unfortunately, your payment is still in process. If you clicked "Cancel payment" button on Landing page, please cancel the payment in Vipps/MobilePay application. Otherwise, your payment will be expired in 10 minutes.'
        }
      }
    }
  },

  pages: {
    setup: {
      menu: {
        getstarted: {
          header: 'Welcome to Zietwing',
          description: 'Hi {0} <br /> Please go through this setup to get started',

          button: 'Lets Go!'
        },

        profilesetup: {
          header: 'Lets get your profile set up',
          description: 'We need some information about you to get started. <br /> Please fill out the form on the left.'
        },

        socialNumberSetup: {
          header: 'Please indicate your social number (CPR)',
          description: 'This information will be displayed only in your Profile section and will be used for creating <b>Invoices</b>. <br /> Please fill out the form on the left.'
        },

        companysetup: {
          header: 'Company Information',
          description: 'If you are registering as a company <br /> please take the time to fill out the form on the left'
        },

        paymentmethod: {
          header: 'Payment Method',
          description: 'Register your card with Zietwing and benefit from enhanced system usability'
        },

        firstservice: {
          header: 'Your First Service',
          description: 'Go ahead and click the button to the left to begin the sign up process'
        }
      },

      content: {
        profilesetup: {
          header: 'Profile Setup',
          subtext: 'Let\'s set up your profile'
        },

        socialNumberSetup: {
          header: 'Social Number Setup',
          subtext: 'Please indicate your Social Number (CPR)'
        },

        companysetup: {
          header: 'Company Information',
          subtext: 'Fill out the form below if you are registering as a company'
        },

        paymentmethod: {
          header: 'Payment Method',
          subtext: 'Enhance your user experience by registering your card in Zietwing',

          skiptext: 'Or if you want to skip this step entirely and set it up later.',
          skip: 'Skip Step'
        },

        firstservice: {
          header: 'Your First Service',
          subtext: 'Let\'s get you signed up for your first service',
          text: 'You are almost done! The following guide will help you sign up for your first service. Click the button below to get started',

          button: 'Okay, I\'m ready!'
        }
      },

      form: {
        firstname: 'First Name',
        lastname: 'Last Name'
      },

      usersuccess: {
        header: 'Your Account is Ready!',
        message: 'Thank you for setting up your account with Zietwing. <br /> Your account is ready for deployment. You can always change the data you have entered on the profile page.',
        button: 'Ok, Got It!'
      },

      validation: {
        success: {
          user_success: 'Your user information has been saved.',
          company_success: 'Your company information has been saved.'
        }
      }
    },

    login: {
      header: 'Log in',
      forgotpass: 'Forgot your password?',
      form: {
        email: 'Email',
        password: 'Password',
        remember: 'Remember me',
        button: 'Log in'
      },
      errors: {
        header: '<b>Whoops!</b> Something went wrong',
        missing_email_and_password: 'Please enter your Email and Password',
        missing_email: 'Please enter your Email',
        missing_password: 'Please enter your Password',
        invalid_credentials: 'Invalid Credentials',
        something_went_wrong: 'Something went wrong...'
      }
    },

    forgot: {
      header: 'Forgot your password',
      form: {
        email: 'Email',
        button: 'Send password reset link',
        success: 'An mail has been sent to you!'
      },

      goback: 'Go back to the',
      loginlink: 'Log in'
    },

    resetpassword: {
      header: 'Change your password',
      form: {
        email: 'Email',
        password: 'New Password',
        password_confirmation: 'Confirm Password',

        button: 'Reset Password',

        success: 'Password has succesfully been changed.'
      },

      goback: 'Go back to the',
      loginlink: 'Log in',

      redirectlink: 'Click here if you are not automatically being redirected',

      validation: {
        success: {},

        errors: {
          link_invalid: 'Link is no longer valid.',
          try_again: 'Please try again later or contact merchant.'
        }
      }
    },

    register: {
      header: 'Welcome to Zietwing, please set your password',

      form: {
        email: 'Email',
        password: 'Password',
        password_confirmation: 'Confirm Password',

        button: 'Register',

        success: 'Your registration has been completed.',

        i_accept: 'I accept the',
        termsandconds: 'Terms and Conditions'
      },

      redirectlink: 'Click here if you are not automatically being redirected'
    },

    register_external: {
      form: {
        success: 'Thank you for registration! You will be redirected in few seconds'
      },
      already_have_account: 'Already have an account?',
      validation: {
        errors: {
          already_exist: 'User with this email already exists.',
          merchant_not_found: 'Unfortunately, Merchant not found. Try again later'
        }
      }
    },

    dashboard: {
      title: 'Dashboard',
      availproducts: 'Available Products',

      details: {
        header: 'Subscription Details',
        subscriptions: 'Subscription(s)',
        mobile_pay_instant_notice: 'Please note that you will receive a push notification in your MobilePay/Vipps application on Transaction Date and will need to accept the Payment. Please make sure that phone number in Profile settings is correct and linked to your MobilePay/Vipps application.',
        kamstrup: {
          headers: {
            meter_info: 'Water Meter Information',
            meter_data: 'Meter Reading data'
          },
          meter_serial_number: 'Meter Serial Number',
          meter_type: 'Meter Type',
          consumption_type: 'Consumption Type',
          previous_period: 'Previous period',
          current_period: 'Current period',
          from: 'From',
          to: 'To',
          total: 'Total',
          payment: {
            upcoming: 'Payment for current period will be performed soon!',
            overdue: 'We were not able to perform payment for current period!',
            no_updated_info: 'As soon as water meter data appears in the system, next payment will be updated!',
            no_data: 'No meter data yet',
            paid: 'Payment for current period is paid!'
          }
        }
      },

      subscriptions: {
        header: 'Subscriptions',
        paymentinterval: 'Payment Interval',
        upcomingtrans: 'Upcoming Transaction(s)',
        processedpayment: 'Processed Payment(s)',
        paymethod: 'Payment Method',
        accessories: 'Accessories',
        activation_on: 'Activation on',
        period_price: 'Price for the period {start} – {end}',
        final_period_price: 'Paid final period {start} – {end}',
        final_period_paid: 'The final period {start} – {end} has been paid. No further automatic payments will be created for this subscription.',
        manually_adjusted: 'manually adjusted',

        add_payment_method: {
          title: 'Add payment method',
          description: 'Choose a payment method for future automatic payments. You will not be charged during setup.'
        },

        validation: {
          are_you_sure: 'Are you sure you want to cancel this subscription?',
          are_you_sure_change_card: 'Are you sure you want to change card for the product {product_name}?',
          are_you_sure_change_card_body_text_lead: 'Your payment card will be updated only for {product_name}.',
          are_you_sure_change_card_body_text_note: 'If you have other subscriptions, you need to update the card separately for each product.'
        }
      }
    },

    archive: {
      title: 'Archived subscriptions',
      meta: 'Archive',

      table: {
        'name': 'Name',
        'interval': 'Interval',
        'price': 'Price',
        'last_payment': 'Last payment'
      }
    },

    payments: {
      header: 'Payment',

      filter: {
        header: 'Transactions for {merchantname}',
        description: ''
      },

      payment: {
        processed: 'Processed Payments',
        upcoming: 'Upcoming Payments',

        error: {
          noprocessedfound: 'No processed payments found',
          noupcomingfound: 'No upcoming payments found'
        }
      }
    },

    bookings: {
      header: 'Booking',

      available_bookings: 'Available products',

      reserved_bookings: {
        table: {
          product: 'Product',
          start_time: 'Start time',
          end_time: 'End time',
          status: 'Status',
          price: 'Price',
          actions: 'Actions'
        },

        labels: {
          free: 'Free',
          pay: 'Pay',
          calendar: 'Calendar',
          overview: 'Overview',
          activate: 'Activate'
        }
      },

      validation: {
        delete_booking: {
          title: 'Are you sure you wan\'t to delete this booking?',
          header: 'This will delete the booking from your profile',
          text: '<p>The selected time and date might not be available if you try to book it again<p/>'
        },

        error: {},

        success: {
          booking_deleted: 'Your booking has been deleted!',
          booking_added_free: 'Your booking has been added!',
          booking_added_paid: 'Your booking has been added! Payment time - {payment_time}',
          booking_paid: 'Your booking has been added!',
          booking_agreement_confirmed: 'Your booking is confirmed! The amount will be charged via Vipps/MobilePay on the payment date.',
          booking_edited: 'Your booking has been updated!'
        }
      }
    },

    profile: {
      settings: {
        profile: {
          header: 'Profile',
          form: {
            email: 'Email',
            password: 'Password',
            change_password: 'Changing password requires current password',
            first_name: 'First Name',
            last_name: 'Last Name',
            social_number: 'CPR number'
          }
        },

        privacy: {
          header: 'Privacy Settings',

          userdata: {
            header: 'Right to insight',
            body: 'You have the right to see which data Zietwing stores about you and you can request to receive your user data.',
            button: 'Request user data',

            modal: {
              title: 'Are you sure you want to request your user data?',
              header: 'Request to see which data Zietwing stores about me?',
              body: '<p>You will receive a file within 7-10 days containing the data Zietwing has stored about you. Use the data at your own discretion.</p>'
            }
          },

          forgotten: {
            header: 'Right to be forgotten',
            body: 'As a Zietwing user you have the right to be forgotten. Zietwing will erase your profile data.',
            button: 'Request to be forgotten',

            modal: {
              title: 'Are you sure you want to be forgotten?',
              header: 'Zietwing will forget your information.',
              body: '<p>We expect to process your request within 7-10 days. This action is final and can subsequently not be reversed.Please contact Zietwing(<a href = "mailto:support@zietwing.com" > support@zietwing.com</a>) within 5 days if you wish to cancel your request.</p><p>Zietwing will inform your active merchants about your decision.</p>'
            },

            validation: {
              success: {
                request_received: 'Request received!',
                receive_message: 'You will receieve a message when your request has been processed.'
              }
            }
          }
        },

        documentation: {
          header: 'Documents'
        },

        payment: {
          header: 'Payment Settings',
          button: 'New Payment Method'
        }
      },

      validation: {
        success: {
          user: {
            saved: 'Profile Saved',
            updated: 'Your Profile has been updated!'
          },

          email: {
            saved: 'Email Saved',
            updated: 'Your Email has been updated!'
          },

          password: {
            saved: 'Password Saved',
            updated: 'Your Password has been updated!'
          }
        }
      }
    },

    notfound: {
      not_found: 'We couldn\'t find that page',
      go_back: 'Click here to go back'
    },

    wait_list: {
      header: 'Waiting List',
      available_products: 'Available Products',
      no_waitinglist: 'No waiting list subscriptions found.'
    },

    checkout: {
      general: {
        title: 'Before completing your payment:',
        hint_1: 'Double-check your card details (number, expiry date and CVV)',
        hint_2: 'Make sure your card allows online payments',
        hint_3: 'If the payment fails, try another card or contact your bank'
      },
      update: {
        title: 'Please check the following information before proceeding:',
        hint_1: 'While updating payment information, Nets Easy will reserve and cancel the specified amount.',
        hint_2: 'Charge will happen on transaction date.',
        hint_3: 'Please don\'t forget to return to the browser after you confirm payment in mobile application (if any).',
      },
      kamstrup: {
        title: 'Please check the following information before proceeding:',
        hint_1: 'On the initial setup, price is 0.',
        hint_2: 'This amount will be canceled as soon as you complete checkout!',
        hint_3: 'Charges will depend on the amount of water used.'
      }
    },

    water_usage: {
      title: 'Water usage',
      meter_serial_number: 'Meter serial number',
      filter: {
        from: 'From',
        to: 'To',
        house_meter: 'Address'
      },
      table: {
        date: 'Date',
        start_meter: 'Start meter',
        end_meter: 'End meter',
        total: 'Used (m³)',
        info_codes: 'Info codes',
        pagination: {
          prev: 'Previous',
          next: 'Next'
        }
      },
      hourly: {
        title: 'Water usage by hour',
        no_data: 'No hourly water usage found for the selected date.',
        total_per_day: 'Total for this day (m³)',
        table: {
          hour: 'Hour'
        }
      }
    },

    kamstrup_alarm_settings: {
      title: 'Water Alarm Settings',
      description: 'Set custom water usage alarm thresholds for your subscriptions.',
      default_settings: 'Merchant default: {threshold}% increase and at least {min} m3 difference.',
      no_merchant_defaults: 'The merchant has not configured default alarm settings. You can still create custom settings for your subscriptions.',
      no_subscriptions: 'No active subscriptions are available for alarm settings.',
      use_custom: 'Use custom settings',
      use_default: 'Use merchant default',
      threshold_percentage: 'Increase percentage',
      min_absolute_volume: 'Minimum difference (m3)',
      max_daily_volume: 'Maximum daily usage (m3)',
      max_daily_volume_help: 'Optional. Use this to get an alarm when one day uses too much water, even if the usage does not increase compared with the day before.',
      optional: 'Optional',
      required_fields: 'Increase percentage and minimum difference are required.',
      saved: 'Alarm settings saved.',
      threshold_percentage_help: 'How much higher yesterday must be compared with the day before.',
      min_absolute_volume_help: 'Prevents alarms for tiny changes. 0.20 m3 is about 200 liters.',
      how_it_works: {
        title: 'How alarms are sent',
        intro: 'Every day the system compares yesterday\'s water usage with the previous day.',
        percentage_title: 'Increase percentage',
        percentage_text: 'An alarm can be sent when yesterday is this many percent higher than the day before. Example: if this is 50%, usage from 0.40 to 0.70 m3 is high enough by percentage.',
        minimum_title: 'Minimum difference',
        minimum_text: 'The increase must also be at least this many m3. Example: if this is 0.20 m3, usage from 0.40 to 0.50 m3 does not send an alarm because the difference is only 0.10 m3.',
        maximum_title: 'Maximum daily usage',
        maximum_text: 'Optional. This is a fixed daily limit. Example: if this is 1.00 m3, an alarm is sent for any day where total usage is 1.00 m3 or higher, even if yesterday and the day before used the same amount.'
      }
    }
  },

  components: {
    languageselector: {
      header: 'Language',

      languages: {
        danish: 'Danish',
        english: 'English'
      }
    },

    notificationbell: {
      header: 'Notifications',
      new: 'new',
      messages: {
        service_unset: 'This service is unfinished, click here to finish it',
        no_new: 'No new notifications found'
      }
    },

    transaction: {
      paymentstatus: {
        approved: 'Payment approved',
        approved_manually: 'Manual payment approved',
        denied: 'Payment denied',
        upcoming: 'Upcoming payment',
        overdue: 'Payment is overdue'
      },

      info: {
        paymentinfo: 'Your Payment Info',
        overdue_fee: 'Overdue fee',
        endingin: 'ending in',
        paid: 'Paid the {date} at {time}',
        to_be_paid: 'To be paid the {date}',
        tried: 'Payment was tried the {date} at {time}',
        fail_reason: 'Description: {reason}',
        refunding: 'Transaction is currently refunding',
        refunded: 'Payment refunded on {date} at {time}',
        accessories: 'Accessories',
        merchantinfo: 'Merchant Info',
        purchase: 'Your Purchase',
        expire_date: 'Expiration Date',
        total: 'Total',
        water_rate: 'Water Rate (per m³)',
        pending_meter_notice: 'This is the rate per cubic meter. Final charge will be based on water usage.',
        accessories_included: 'Accessories included in above rate'
      }
    },

    accessory: {
      added: 'Added',
      select: 'Select',
      mandatory: 'Mandatory'
    },

    paymentplan: {
      chosen_accessory: 'Chosen Accessories',
      chosen_product: 'Chosen Product',
      starting_fee: 'Startup fee',

      intervals: {
        instant: 'Instant payment',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        biannually: 'Biannually',
        annually: 'Annually'
      }
    },

    card: {
      card_holder: 'Card Holder',
      expires: 'Expires',
      no_card: 'No Payment Card'
    },

    service: {
      payment_date: 'Payment date:',
      payment_type: 'Payment type',
      payment_method: 'Payment Method',
      price: 'Price',
      unset: 'Unset',
      no_price: 'No price',
      select_status: 'Select status',

      status: {
        inactive: 'Inactive',
        active: 'Active',
        unset: 'Not finished',
        overdue: 'Overdue'
      },

      details: {
        header: 'Details'
      },

      transactions: {
        header: 'Latest transactions'
      },

      validation: {
        cancel_service: 'Are you sure you want to cancel your waitlist?',
        update_payment_information: 'Are you sure you want to update your payment information?',

        success: {
          service_cancelled: 'The subscription has been cancelled.',
          details_updated: 'Your details has been saved.'
        }
      }
    }
  }
}

export default en



// WEBPACK FOOTER //
// ./src/assets/lang/en.js